import { application } from 'src';
import { Controller } from '@hotwired/stimulus';
import { findAll } from '@fretadao/f-js-dom';

application.register(
  'checkbox-counter',
  class extends Controller {
    static targets = ['counter'];

    connect() {
      this.setCounterHandler = this.#setCounter.bind(this);

      this.#checkboxes().forEach(el => {
        el.addEventListener('change', this.setCounterHandler);
      });

      this.element.addEventListener('checkboxesChanged', this.setCounterHandler);

      this.#setCounter();
    }

    disconnect() {
      this.#checkboxes().forEach(el => {
        el.removeEventListener('change', this.setCounterHandler);
      });

      this.element.removeEventListener('checkboxesChanged', this.setCounterHandler);
    }

    #setCounter() {
      let checkedElements = this.#checkboxes({ checked: true });
      let distinctElements = new Set(checkedElements.map(el => el.id));

      this.counterTarget.innerHTML = distinctElements.size;
    }

    #checkboxes({ checked = null } = {}) {
      let query = 'input[type=checkbox]'

      if (checked != null) query = query.concat(':checked');

      return findAll(query, this.element);
    }
  }
);
